import { getAllowedNetworkUrls } from './sentry-config';
import TokenService from '@paybis/frontend-common-lib/src/services/token';
import store from '@/store';
import { setTags } from '@sentry/browser';
import { isUserCountryUK } from '@/helpers/userCountry';
import scrubRequestData from '@/utilities/sentryScrubber';

export const addSentryReplay = (Sentry) => {
  const client = Sentry.getCurrentHub().getClient();
  if (client && !client._integrations.replayIntegration) {
    const replay = Sentry.replayIntegration({
      maskAllText: false,
      maskAllInputs: true,
      blockAllMedia: false,
      networkDetailAllowUrls: getAllowedNetworkUrls(),
      networkCaptureBodies: true,
      beforeAddRecordingEvent: event => {
        const user = TokenService.getUser();
        const invoice = store.getters['transaction/invoice'];

        if (user) {
          Sentry.setUser(user);
        }

        if (invoice) {
          setTags({ invoice });
        }

        // XXX: scrub sensitive request data from Replay events
        if (event.data?.payload.op === 'resource.xhr') {
          const requestBody = event.data?.payload.data?.request.body;
          const responseBody = event.data?.payload.data?.response.body;

          if (requestBody) {
            event.data.payload.data.request.body = scrubRequestData(requestBody);
          }

          if (responseBody) {
            event.data.payload.data.response.body = scrubRequestData(responseBody);
          }
        }

        return event;
      },
    });

    client.addIntegration(replay);

    if (isUserCountryUK()) {
      replay.start();
    }
  }
};

